import React from "react";
import ReactDOM from "react-dom";
import createHistory from "history/createBrowserHistory";
import configureStore from "./store/configureStore";
import { Router, Route } from "react-router";
import { Redirect, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { unregister } from "./registerServiceWorker";
import App from "components/App";
import Product from "containers/Product";
import ProductDetail from "containers/ProductDetail";
import Store from "containers/Store";
import Brochure from "containers/Brochure";
import Recipe from "containers/Recipe";
import RecipeDetail from "containers/RecipeDetail";

const root = (
  <Provider store={configureStore()}>
    <Router history={createHistory()}>
      <Switch>
        <Route exact path="/:brand/products" component={App(Product)} />
        <Route
          path="/:brand/products/:product"
          component={App(ProductDetail)}
        />
        <Route path="/:brand/stores" component={App(Store)} />
        <Route path="/:brand/brochures" component={App(Brochure)} />
        <Route exact path="/:brand/recipes" component={App(Recipe)} />
        <Route path="/:brand/recipes/:id" component={App(RecipeDetail)} />
        <Redirect from="/" to="/asko/products" />
      </Switch>
    </Router>
  </Provider>
);

ReactDOM.render(root, document.getElementById("root"));
unregister();



// WEBPACK FOOTER //
// ./src/index.js